import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "list__header"
}
const _hoisted_3 = { class: "list__title" }
const _hoisted_4 = { class: "list__subtitle" }
const _hoisted_5 = { class: "list__items" }
const _hoisted_6 = { class: "list__item-title" }
const _hoisted_7 = { class: "list__item-subtitle" }
const _hoisted_8 = {
  key: 1,
  class: "list__footer"
}

import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';
import SmTextButton from '@/components/ui/buttons/SmTextButton/SmTextButton.vue';

import { IListProps } from '@/@types/components/ui/lists';

import '@/components/ui/SmList/style.scss';

// [SATRT] Props

export default /*#__PURE__*/_defineComponent({
  __name: 'SmList',
  props: {
    showHeader: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: false },
    header: {},
    list: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }) {

const props = __props;



// [END] Props

// [SATRT] Emits

// [END] Emits

// [START] Methods
const handleClick = () => emits('click');
// [END] Methods

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.showHeader && props.header)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "header", {
            header: props.header
          }, () => [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(props.header.title), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(props.header.subtitle), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `list-item-${i}`,
          class: "list__item"
        }, [
          _renderSlot(_ctx.$slots, "default", {
            item: item,
            index: i
          }, () => [
            (typeof item === 'object')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_7, _toDisplayString(item.subtitle), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(item), 1)
                ], 64))
          ])
        ]))
      }), 128))
    ]),
    (props.showFooter)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createVNode(SmTextButton, {
              type: "primary",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(SmIcon, {
                  name: "Plus",
                  size: "16"
                }),
                _createTextVNode(" Добавить новый ")
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})